/**
 * Created by Darius on 2017.03.05.
 */
import React, {Component} from "react";
import {connect} from 'react-redux';
import {AppBar} from "material-ui";
import SideMenu from "./side-menu";


class ListAppBar extends Component {
    constructor(props, context) {
        super(props, context);

        this.openSideMenu = this.openSideMenu.bind(this);
    }

    openSideMenu(event) {
        this.props.openSideMenu();
    }

    render() {

        return (
            <div>
                <AppBar title={this.props.title} onLeftIconButtonTouchTap={this.openSideMenu} iconElementRight={this.props.iconElementRight}/>
                <SideMenu/>
            </div>
        );
    }
}
const mapStateToProps = state => ({...state.common});

const mapDispatchToProps = dispatch => ({
    openSideMenu: () =>
        dispatch({type: 'OPEN_SIDE_MENU', payload: true})
});

ListAppBar = connect(mapStateToProps, mapDispatchToProps)(ListAppBar);

export default ListAppBar;